module.exports = __webpack_public_path__ + "de77a722/img/scraper-icon.df6ccde5.svg";